import { useEffect, useState } from 'react'
import useApi from './../utilities/useApi';
import arrayUtilities from '../utilities/arrayUtilities';
import stringUtilities from '../utilities/stringUtilities';
import roleUtilities from '../utilities/roleUtilities';
import OrganisationSelector from './common/organisationSelector';
import { Button, Col, Container, Form, InputGroup, Row, Table, Dropdown, Modal } from 'react-bootstrap';
import FilterBar from './common/filterBar';
import Loading from './common/loading';
import cloneDeep from 'lodash.clonedeep';
import hash from 'object-hash';
import Enums from "../utilities/enums";
import { useNavigate } from 'react-router-dom'

export default function Users(props) {
    const { api } = useApi();
    const navigate = useNavigate();    
    const [isLoading, setIsLoading] = useState(true);
    const [includeDeleted, setIncludeDeleted] = useState(false);
    const [filter, setFilter] = useState("");
    const [users, setUsers] = useState(null);
    const [filteredUsers, setFilteredUsers] = useState(null);
    const [undeleteUserError, setUndeleteUserError] = useState(null);
    const [deleteActionModal, setDeleteActionModal] = useState(null);
    const [postResetEmailModal, setPostResetEmailModal] = useState(null);
    const canManageUsers = roleUtilities.hasElevatedCapability(props.user)

    const getUsers = function () {

        if (!stringUtilities.isNullOrEmpty(props.organisationId)) {

            setIsLoading(true);
            api.getUsers(props.organisationId, includeDeleted, (data) => {
                setUsers(data);
                setIsLoading(false);
            }, () => {
                setIsLoading(false);
            });
        }
    };

    const setUserEnabled = function (userId, enabled) {
        api.patchUser(props.organisationId, userId, !enabled, null, () => getUsers(), () => {
        });
    }

    const deleteUser = function (userId) {
        api.deleteUser(props.organisationId, userId, () => {
            setDeleteActionModal(null);
            if (includeDeleted) {
                let copy = cloneDeep(users);
                let user = copy.find(x => x.id === userId);
                user.deleted = true;

                setUsers(copy);
            } else {
                setUsers(users.filter(x => x.id !== userId));
            }
        }, () => {

        });
    }

    const undeleteUser = function (userId) {
        api.patchUser(props.organisationId, userId, null, false, (response) => {
            if (response.isError) {
                console.log(response.errorMessage);
                setUndeleteUserError(response.errorMessage);
            }
            else {
                let copy = cloneDeep(users);
                let user = copy.find(x => x.id === userId);
                user.deleted = false;           
                setUsers(copy);
                setDeleteActionModal(null);
            }
        }, () => {

        });
    }

    useEffect(() => {
        setFilteredUsers(arrayUtilities.isNullOrEmpty(users) ? [] : users.filter((user) => {
            return stringUtilities.isNullOrEmpty(filter) || user.name.toLowerCase().indexOf(filter.toLowerCase()) > -1 || user.emailAddress.toLowerCase().indexOf(filter.toLowerCase()) > -1;
        }));
    }, [filter, users]);

    useEffect(() => {
        getUsers();
    }, [props.organisationId, includeDeleted]);

    const handlePasswordReset = (userId) => {
        setIsLoading(true)
        api.resetPassword(
            userId, props.organisationId,
            data => {
                setIsLoading(false)
                if (data.isError) {
                    setPostResetEmailModal({
                        title: "Error",
                        content: <>There was an error sending the password reset email: {data.errorMessage}</>
                    })
                } else {
                    setPostResetEmailModal({
                        title: "Success",
                        content: <>The password reset email was successfully sent.</>
                    })
                }
            },
            error => {
                console.log(error);
                setPostResetEmailModal({
                    title: "Error",
                    content: <>There was an error sending the password reset email: {error.message}</>
                })
                setIsLoading(false);
            }
        )
    }

    return <>
        <Container className='pt-5 pb-lg-4 mt-5 mb-sm-2 report user-activity-report'>
            <Row>
                <Col className='mb-5'>
                    <div className='d-flex justify-content-between my-5'>
                        <h1 className="h2 m-0">Users</h1>

                        <div className='d-flex justify-content-end'>

                            <Form.Group className='d-flex align-items-center flex-shrink-0 me-4'>
                                <Form.Label className='text-body fs-sm me-2 mb-0 pe-1 text-nowrap'>
                                    Include deleted
                                </Form.Label>
                                <InputGroup size="sm">
                                    <Form.Check type='switch' id="include-deleted" className="me-2 pt-2" checked={ includeDeleted } onChange={ (e) => setIncludeDeleted(e.target.checked) } />
                                </InputGroup>
                            </Form.Group>

                            <FilterBar value={ filter } onChange={ setFilter } className="me-4" />
                            <OrganisationSelector value={ props.organisationId ?? props.organisationalUnits[0].id } organisations={ props.organisationalUnits } onChange={ 
                                id => {
                                    props.changeOrgId(id);
                                    navigate(`/${id}/users`)
                                }
                             } />


                            {
                                canManageUsers &&
                                <Button size='sm' className='ms-2' onClick={ () => navigate(`/${props.organisationId}/users/add`) }>
                                    <i className='fi-plus me-2'></i>
                                    Add user
                                </Button>
                            }
                        </div>
                    </div>

                    { isLoading && <Loading /> }
                    { !isLoading &&

                        <Table hover sm>
                            <thead>
                                <tr>
                                    <th>SID(s)</th>
                                    <th>Name</th>
                                    <th>Email Address</th>
                                    <th>Role</th>
                                    <th>Capability</th>
                                    <th className='text-center'>Enabled</th>
                                    {canManageUsers && <th></th>}
                                </tr>
                            </thead>
                            <tbody>
                                { !arrayUtilities.isNullOrEmpty(filteredUsers) && filteredUsers.map((user, index) => <tr index={ index } key={ hash(user) } className='align-middle'>
                                    <td>
                                        {
                                            user.licenses.map(
                                                (item, index) => <span className={user.deleted ? "text-muted" : ""} key={item.sid}>{index > 0 && <br />} {item.sid}</span>
                                            )
                                        }
                                    </td>
                                    <td>
                                        <span className={ user.deleted ? `text-muted` : "" }>{ user.name }</span>
                                    </td>
                                    <td>
                                        <span className={ user.deleted ? `text-muted` : "" }>{ user.emailAddress }</span>
                                    </td>
                                    <td>
                                        <span className={ user.deleted ? `text-muted` : "" }>{ Enums.UserRole[user.roleId] }</span>
                                    </td>
                                    <td>
                                        { !arrayUtilities.isNullOrEmpty(user.capabilityIds) && 
                                        user.capabilityIds.map((item, index) => <span key={item}>{index > 0 && <br />}{Enums.UserCapability[item]}</span>)}
                                    </td>
                                    <td className='text-center'>
                                        <Form.Check type='switch' id={ `user-${ user.id }-enabled` } className="me-2" value={ user.id } defaultChecked={ !user.disabled } disabled={ user.deleted || !canManageUsers } onChange={ (e) => setUserEnabled(user.id, e.target.checked) } />
                                    </td>
                                    {
                                        canManageUsers &&
                                        <td className='text-end'>
                                            <Dropdown>
                                                <Dropdown.Toggle className='bg-none btn-secondary organisation-options-dropdown-toggle'><i className='fi-dots-vertical'></i></Dropdown.Toggle>
                                                <Dropdown.Menu align='end' className='my-1'>
                                                    {
                                                        user.deleted &&
                                                        <Dropdown.Item onClick={() => {
                                                            setDeleteActionModal({
                                                                title: "Un-delete user",
                                                                content: <>
                                                                Are you sure you want to un-delete the user { user.emailAddress }?
                                                                { undeleteUserError && <p className="text-danger" style={{fontSize: "0.75rem"}}>Error: {undeleteUserError}</p>}
                                                                </>,
                                                                onConfirm: () => undeleteUser(user.id)
                                                            })
                                                        }}>
                                                            Un-delete
                                                        </Dropdown.Item>
                                                    }
                                                    {
                                                        !user.deleted &&
                                                        <>
                                                            <Dropdown.Item onClick={ () => handlePasswordReset(user.id) }>Password Reset</Dropdown.Item>
                                                            <Dropdown.Item onClick={() => navigate(`/${props.organisationId}/users/${user.id}`)}>Edit</Dropdown.Item>
                                                            <Dropdown.Divider as='div' />
                                                            <Dropdown.Item onClick={() => {
                                                                setDeleteActionModal({
                                                                    title: "Delete user",
                                                                    content: <p>Are you sure you want to delete the user { user.emailAddress }?</p>,
                                                                    onConfirm: () => deleteUser(user.id)
                                                                })
                                                            }}>
                                                                Delete
                                                            </Dropdown.Item>
                                                        </>
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    }
                                </tr>) }
                            </tbody>
                        </Table>
                    }

                </Col>
            </Row>
        </Container>
            
        {
            deleteActionModal && 
                <Modal show onHide={() => {
                    setDeleteActionModal(null);
                    setUndeleteUserError(null);
                }} centered>
                    <Modal.Header>
                        <Modal.Title>{deleteActionModal.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {deleteActionModal.content}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size="sm" variant='secondary' onClick={() => {
                            setDeleteActionModal(null);
                            setUndeleteUserError(null);
                        }}>Cancel</Button>
                        <Button size="sm" variant="primary" onClick={deleteActionModal.onConfirm}>Confirm</Button>
                    </Modal.Footer>
                </Modal>
        }
        {
            postResetEmailModal && 
                <Modal show onHide={() => setPostResetEmailModal(null)} centered>
                    <Modal.Header>
                        <Modal.Title>{postResetEmailModal.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {postResetEmailModal.content}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size="sm" variant='secondary' onClick={() => setPostResetEmailModal(null)}>Close</Button>
                    </Modal.Footer>
                </Modal>
        }
    </>;
}